<template>
  <CollapseCard
    :visible="item.visibleCollapse"
    :shouldToggleWithHeader="true"
    accordion=""
    backgroundColor="surface"
    borderColor="complementary-50"
    @handleShow="handleOpenCollapse"
    @handleHidden="handleCloseCollapse"
  >
    <template #header>
      <div class="flex-between width-percent-100">
        <div cols="12" class="padding-0 flex-start desktop-none">
          <fade-transition>
            <StatusBox
              v-if="!isOpenCollapse && isIndicatorVerificationMethodByAssessor"
              :item="item"
            />
          </fade-transition>
        </div>
        <IndicatorCaption
          rowClass="mobile-none tablet-none"
          :indicatorType="item.value"
          :code="item.code"
          :caption="item.caption"
        />
        <div class="flex-end">
          <ErrorCount
            class="margin-left-8"
            :visible="!isOpenCollapse && item.hasError"
            :count="item.errorsCount"
          />
          <fade-transition>
            <StatusBox
              v-if="!isOpenCollapse && isIndicatorVerificationMethodByAssessor"
              class="mobile-none tablet-none margin-left-8"
              :item="item"
            />
          </fade-transition>
        </div>
      </div>
    </template>
    <template #header-second-row>
      <IndicatorCaption
        rowClass="desktop-none margin-top-16"
        :indicatorType="item.value"
        :code="item.code"
        :caption="item.caption"
      />
    </template>
    <template #body>
      <b-row class="margin-0">
        <b-col cols="12" class="padding-0">
          <ul
            class="margin-0 padding-0 border--solid border--complementary-50 border--right list-style--none margin-right-8 padding-right-8"
          >
            <li
              v-for="(evidence, index) in item.evidences"
              :key="`evidence-${index}`"
            >
              <EvidenceItem :item="evidence" :indicatorCaption="item.caption" />
            </li>
          </ul>
        </b-col>
        <b-col
          v-if="isIndicatorVerificationMethodByAssessor"
          cols="12"
          class="padding-0"
        >
          <StatusBox
            :item="indicatorsLoading ? null : item"
            :justView="false"
          />
        </b-col>
      </b-row>
    </template>
  </CollapseCard>
</template>

<script>
import { CollapseCard, ErrorCount } from "@/components/re-design";
import EvidenceItem from "../evidence/EvidenceItem.vue";
import StatusBox from "./StatusBox.vue";
import IndicatorCaption from "./IndicatorCaption.vue";
import { computed, inject, provide, ref, toRefs } from "vue";
export default {
  components: {
    CollapseCard,
    ErrorCount,
    EvidenceItem,
    StatusBox,
    IndicatorCaption,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    indicatorsLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // bind props data
    const { item } = toRefs(props);

    // bind injects data
    const isIndicatorVerificationMethodByAssessor = inject(
      "IS_INDICATOR_VERIFICATION_METHOD_By_ASSESSOR"
    );

    const isOpenCollapse = ref(true);
    const handleOpenCollapse = () => (isOpenCollapse.value = true);
    const handleCloseCollapse = () => (isOpenCollapse.value = false);

    provide(
      "INDICATOR_ID",
      computed(() => item.value.id)
    );

    // return data to be used in template
    return {
      item,
      isOpenCollapse,
      handleOpenCollapse,
      handleCloseCollapse,
      isIndicatorVerificationMethodByAssessor,
    };
  },
};
</script>
